<div class="modal-dialog modal-lg" role="document">
  <div class="modal-content" [formEditablePermission]="form">
    <div class="modal-header">
      <div class="d-flex align-items-center gap-3 flex-fill">
        <div class="d-flex align-items-center gap-2">
          <h6 *ngIf="isEdit" i18n class="modal-title">Edit Document Automation</h6>
          <h6 *ngIf="!isEdit" i18n class="modal-title">New Document Automation</h6>
          <app-page-help articleId="nM6G7JwGKE9eiyt8ThH5U3"></app-page-help>
        </div>
        <div class="flex-fill"></div>
        <app-form-switch
          *ngIf="isEdit"
          (valueChange)="onTogglePause($event)"
          [formControl]="form.get('status')"
          [disabled]="1 | isReadonlyRole"
          [matTooltip]="getStatusTooltip()"
          matTooltipPosition="above"
          [inline]="true"
        >
          {{ form.get('status').value ? 'Active' : 'Inactive' }}
        </app-form-switch>
        <button
          *ngIf="isEdit"
          (click)="onDelete()"
          [disabled]="1 | isReadonlyRole"
          class="btn btn-secondary-danger"
          type="button"
        >
          <i class="cs-icon cs-icon-trash"></i><ng-container i18n>Delete</ng-container>
        </button>
        <button
          (click)="onSave(form)"
          class="btn btn-secondary-info save-btn"
          type="button"
          *ngIf="tab === tabs.Overview"
          [disabled]="(1 | isReadonlyRole) || (isSaving$ | async)"
        >
          <i class="cs-icon cs-icon-save"></i><ng-container i18n>Save</ng-container>
        </button>
      </div>
      <a (click)="close()" class="cstm-close">
        <span class="far fa-times"></span>
      </a>
    </div>
    <ul class="nav drawer-right-navbar" role="tablist" *ngIf="isEdit">
      <li [class.active]="tab === tabs.Overview">
        <a (click)="tab = tabs.Overview" i18n-matTooltip matTooltip="Overview" matTooltipPosition="left">
          <i class="fal fa-bolt"></i>
        </a>
      </li>
      <li [class.active]="tab === tabs.Template">
        <a (click)="onEditTemplate()" i18n-matTooltip matTooltip="Template" matTooltipPosition="left">
          <i class="cs-icon cs-icon-template"></i>
        </a>
      </li>
      <li [class.active]="tab === tabs.Activity">
        <a (click)="tab = tabs.Activity" i18n-matTooltip matTooltip="Logs" matTooltipPosition="left">
          <i class="cs-icon cs-icon-calendar-clock"></i>
        </a>
      </li>
    </ul>
    <div class="modal-body">
      <alert *ngIf="isDuplicate" type="warning">
        <strong i18n>Warning:</strong
        ><ng-container i18n>
          This automation is a duplicate. Please modify the automation details, before clicking</ng-container
        >
        <strong i18n>Save</strong><ng-container i18n> to create the automation.</ng-container>
      </alert>
      <ng-container [ngSwitch]="tab">
        <ng-container *ngSwitchCase="tabs.Overview">
          <mat-form-field2 class="mat-block">
            <mat-label i18n>Automation Name</mat-label>
            <input
              matInput
              [formControl]="form.get('name')"
              i18n-placeholder
              placeholder="New message name for this automation"
              required
            />
            <mat-error i18n *ngIf="form.get('name').touched && form.get('name').hasError('required')">
              Name is required
            </mat-error>
          </mat-form-field2>

          <ng-container *ngIf="isEdit">
            <div class="container-box p-3 mb-3">
              <div class="text-uppercase mb-2" i18n>Automation Status</div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="text-sm" i18n>Status:</div>
                  <div *ngIf="form.get('status').value" class="text-success text-semi-bold" i18n>Active</div>
                  <div *ngIf="!form.get('status').value" class="text-danger text-semi-bold" i18n>Inactive</div>
                </div>
                <div class="col-sm-4">
                  <div class="text-sm" i18n>Created:</div>
                  <div class="text-semi-bold">{{ automationGroup?.created | epoch }}</div>
                </div>
                <div class="col-sm-4">
                  <div class="text-sm" i18n>Last Triggered:</div>
                  <div class="text-semi-bold">{{ automationGroup?.lastupdate | epoch }}</div>
                </div>
              </div>
            </div>
          </ng-container>

          <mat-stepper [linear]="true" [disableRipple]="true" class="flex-fill" #stepper>
            <ng-template matStepperIcon="edit">
              <i class="fas fa-check"></i>
            </ng-template>
            <ng-template matStepperIcon="done">
              <i class="fas fa-check"></i>
            </ng-template>
            <mat-step [state]="stepper.selectedIndex > 0 ? 'done' : 'number'">
              <ng-template matStepLabel>
                <div class="text-sm" i18n>When this event occurs</div>
                <div class="text-muted text-xs" i18n>Select an event for your automation</div>
              </ng-template>
              <div class="step-content">
                <ng-template [ngTemplateOutlet]="selectEvent"></ng-template>
                <div class="d-flex align-items-center mt-4">
                  <div class="flex-fill"></div>
                  <button
                    class="btn btn-secondary-info"
                    (click)="stepper.next()"
                    [disabled]="form.get('event').invalid || form.get('timeevent').invalid"
                  >
                    <ng-container i18n>Next</ng-container>
                    <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
                  </button>
                </div>
              </div>
            </mat-step>
            <mat-step
              [state]="stepper.selectedIndex > 1 ? 'done' : 'number'"
              [optional]="true"
              *ngIf="allowsRental || allowsChannel"
            >
              <ng-template matStepLabel>
                <div class="text-sm" i18n>Optional Filters</div>
                <div class="text-muted text-xs" i18n>Select channels and rentals</div>
              </ng-template>
              <div class="step-content">
                <ng-template [ngTemplateOutlet]="selectChannelRentals"></ng-template>

                <div class="d-flex align-items-center gap-3 mt-4">
                  <div class="flex-fill"></div>
                  <button class="btn btn-light" (click)="stepper.previous()">
                    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
                    <ng-container i18n>Previous</ng-container>
                  </button>
                  <button class="btn btn-secondary-info" (click)="stepper.next()">
                    <ng-container i18n>Next</ng-container>
                    <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
                  </button>
                </div>
              </div>
            </mat-step>
            <mat-step [state]="stepper.selectedIndex > 2 ? 'done' : 'number'">
              <ng-template matStepLabel>
                <div class="text-sm" i18n>Perform this action</div>
                <div class="text-muted text-xs" i18n>Select the action you want to perform</div>
              </ng-template>
              <div class="step-content">
                <ng-template [ngTemplateOutlet]="selectHandler"></ng-template>
                <div class="d-flex align-items-center gap-3 mt-4">
                  <div class="flex-fill"></div>
                  <button class="btn btn-light" (click)="stepper.previous()">
                    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
                    <ng-container i18n>Previous</ng-container>
                  </button>
                  <button
                    class="btn btn-secondary-info"
                    (click)="stepper.next()"
                    [disabled]="form.get('handler').invalid"
                  >
                    <ng-container i18n>Next</ng-container>
                    <i class="cs-icon cs-icon-arrow-right-long text-xxs"></i>
                  </button>
                </div>
              </div>
            </mat-step>
            <mat-step [state]="stepper.selectedIndex > 3 ? 'done' : 'number'">
              <ng-template matStepLabel>
                <div class="text-sm" i18n>Template & Signers</div>
                <div class="text-muted text-xs" i18n>Who will send and/or sign the template?</div>
              </ng-template>
              <div class="step-content">
                <ng-template [ngTemplateOutlet]="selectTemplate"></ng-template>

                <div class="d-flex align-items-center gap-3 mt-4">
                  <div class="flex-fill"></div>
                  <button class="btn btn-light" (click)="stepper.previous()">
                    <i class="cs-icon cs-icon-arrow-left-long text-xxs"></i>
                    <ng-container i18n>Previous</ng-container>
                  </button>
                  <button class="btn btn-secondary-info" (click)="onSave(form)" [disabled]="isSaving$ | async">
                    <i class="cs-icon cs-icon-save"></i>
                    <ng-container i18n>Save</ng-container>
                  </button>
                </div>
              </div>
            </mat-step>
          </mat-stepper>
        </ng-container>

        <ng-container *ngSwitchCase="tabs.Activity">
          <app-automation-logs [automationGroup]="automationGroup" class="d-block container-box"></app-automation-logs>
        </ng-container>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #selectEvent>
  <div class="select-block-container" *ngIf="form.get('event') as eventCtrl">
    <div
      class="select-block"
      [class.disabled]="isEdit && eventCtrl.value !== item.event"
      [class.active]="eventCtrl.value === item.event"
      *ngFor="let item of events"
    >
      <a (click)="eventCtrl.setValue(item.event)">
        <i [ngClass]="item.icon + ' ' + item.color"></i>
        <div class="text-nowrap">{{ item.title }}</div>
      </a>
    </div>
  </div>
  <ng-container *ngIf="eventCtrl.value === 'time'">
    <div class="mt-3 container-box p-3">
      <h6 i18n>And these Conditions match:</h6>
      <app-automation-time-form [form]="form.get('timeevent')" [eventCtrl]="eventCtrl"></app-automation-time-form>
    </div>
  </ng-container>
</ng-template>

<ng-template #selectHandler>
  <div class="select-block-container" *ngIf="form.get('handler') as handlerCtrl">
    <div
      class="select-block"
      [class.active]="handlerCtrl.value === item.handler"
      *ngFor="let item of handlers"
      [matTooltip]="item.tooltip"
      matTooltipPosition="below"
    >
      <a (click)="handlerCtrl.setValue(item.handler)">
        <i [ngClass]="item.icon + ' ' + item.color"></i>
        <div class="text-nowrap">{{ item.title }}</div>
      </a>
    </div>
  </div>
</ng-template>

<ng-template #selectChannelRentals>
  <div class="row">
    <div *ngIf="allowsChannel" class="col-md-6">
      <app-select-search
        [items]="channels$ | async"
        [ctrl]="form.get('channels')"
        bindValue="id"
        bindLabel="label"
        [inline]="false"
        i18n-matTooltip
        matTooltip="Select one or more channels. Leaving blank will trigger for all connected API channels and manually created AdvanceCM bookings."
        matTooltipPosition="above"
        i18n-placeholder
        placeholder="From this Channel(s) (Optional)"
        class="mat-block"
      >
        <ng-container class="error-container">
          <mat-error i18n>Channel is required</mat-error>
        </ng-container>
      </app-select-search>
      <div class="alert alert-secondary-info">
        <i class="cs-icon cs-icon-info-circle alert-icon"></i>
        <div class="alert-content text-sm" i18n>All channels will be selected by default if nothing is selected</div>
      </div>
    </div>
    <div *ngIf="allowsRental" class="col-md-6">
      <app-rental-select
        [ctrl]="form.get('rentals')"
        i18n-matTooltip
        matTooltip="Select one or more rentals. Leaving blank will trigger for all rentals."
        matTooltipPosition="above"
        i18n-placeholder
        placeholder="For these Rental(s) (Optional)"
      >
      </app-rental-select>
      <div class="alert alert-secondary-info">
        <i class="cs-icon cs-icon-info-circle alert-icon"></i>
        <div class="alert-content text-sm" i18n>All Rentals will be selected by default if nothing is selected</div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #selectTemplate>
  <div class="row">
    <div class="col-sm-6">
      <div class="container-box p-3">
        <app-automation-document-form
          [form]="form"
          [handler]="handlerCtrl.value"
          [automation]="automationGroup"
          (selectTemplate)="template = $event"
        ></app-automation-document-form>
      </div>
    </div>
    <div class="col-sm-6"></div>
  </div>
</ng-template>
